import React, { useState, useEffect } from "react";
import {
  Typography,
  IconButton,
  CardMedia,
  CardActionArea,
  Card,
  CardContent,
  Grid,
} from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { Add, DeleteForever } from "@material-ui/icons/";
import Loading from "../Loading";
import url from "../../constants/URL";
import { connect } from "react-redux";
import ConfirmationModal from "../ConfirmationModal";

const DeliveryboyPage = (props) => {
  const [deliveryboys, setDeliveryboys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [deleteDeliveryboyId, setDeleteDeliveryboyId] = useState(null);

  useEffect(() => {
    getDeliveryboys();
  }, []);

  async function getDeliveryboys() {
    const token = await JSON.parse(window.localStorage.getItem("persist:auth"))
      .token;
    fetch(`${url}/deliveryboys/${props.seller._id}/?all=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(async (resp) => {
      const boys = await resp.json();
      setDeliveryboys(boys);
      setLoading(false);
    });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div style={{ justifyContent: "center", margin: "30px 0" }}>
      <NavLink
        to={"/register/deliveryboy"}
        exact={true}
        style={{
          background: "cornflowerblue",
          borderRadius: 10,
          textDecoration: "none",
          margin: "10px 0",
          color: "white",
          padding: 20,
        }}
      >
        <IconButton color="inherit">
          <Add />
        </IconButton>
        Register Delivery Boy
      </NavLink>
      <h3
        style={{
          backgroundColor: "bisque",
          padding: 20,
          borderRadius: 20,
          textAlign: "center",
        }}
      >
        Available Delivery Boys
      </h3>
      {deliveryboys.length === 0 ? (
        <h3
          style={{
            color: "gray",
            textAlign: "center",
            marginTop: 60,
            fontStyle: "italic",
          }}
        >
          No delivery boy registered yet
        </h3>
      ) : (
        <Grid container spacing={2}>
          {deliveryboys.map((Deliveryboy) => {
            const { _id, name, image, available, phoneNumber, status } =
              Deliveryboy;
            return (
              <Grid item xs={6} sm={4} md={3} lg={2}>
                <Card
                  variant="outlined"
                  style={
                    available
                      ? { background: "beige" }
                      : { background: "whitesmoke" }
                  }
                >
                  <CardActionArea>
                    <CardContent style={{ padding: 0 }}>
                      <>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            margin: "10px 0",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6" style={{ width: "120px" }}>
                            {name}
                          </Typography>
                          {available && (
                            <div
                              style={{
                                borderRadius: "30px",
                                width: "15px",
                                height: "15px",
                                background: "lawngreen",
                              }}
                            />
                          )}
                        </div>
                        <CardMedia
                          component="img"
                          image={image}
                          style={{
                            height: "160px",
                          }}
                        />
                        <p style={{ textAlign: "center" }}>
                          <i>Phone Number</i>: <b>{phoneNumber}</b>
                        </p>
                        <p style={{ textAlign: "center" }}>
                          <i>Status</i>: <b>{status}</b>
                        </p>
                      </>
                    </CardContent>
                  </CardActionArea>
                  <div style={{ textAlign: "center", margin: "10px 0" }}>
                    <IconButton
                      onClick={() => {
                        setConfirmationModal(true);
                        setDeleteDeliveryboyId(_id);
                      }}
                    >
                      <DeleteForever />
                    </IconButton>
                  </div>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
      <ConfirmationModal
        open={confirmationModal}
        handleClose={() => {
          setConfirmationModal(false);
          setDeleteDeliveryboyId(null);
        }}
        message={"Are you sure to delete this delivery boy?"}
        onConfirm={async () => {
          let token = await JSON.parse(
            window.localStorage.getItem("persist:auth")
          ).token;
          fetch(`${url}/${deleteDeliveryboyId}/deliveryboy/delete`, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }).then(() => window.location.reload());
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  seller: state.auth.seller,
});

export default connect(mapStateToProps)(DeliveryboyPage);
